<template>
  <div class="freecall">
    <main>
      <article>
        <header class="freecall__navbar">
          <h1 class="navbar__title">
            FREE
            <span>CALL</span>
            <p>#5366032</p>
          </h1>
          <div class="navbar__time">
            <span>
              <i class="fas fa-question"></i>
            </span>
            <p>TIME：00:00</p>
            <span>
              <i class="fas fa-undo-alt"></i>
            </span>
          </div>
        </header>
        <section class="freecall__playground">
          <div class="playground__temporaryarea">
            <div v-for="(item, index) in temporaryArea" :key="index"></div>
          </div>
          <div class="playground__finisharea">
            <div v-for="(item, index) in cardtype" :key="index">
              <img :src="getFinishAreaImgUrl(item, index)">
            </div>
          </div>
          <div class="playground__gamingarea">
            <div v-for="(item, index) in 8" :key="index">
              <img v-for="(item, cardnum) in maingameArea[index]" :key="cardnum"
                :src="getPokerImageUrl(item)" :style="getTop(cardnum)">
            </div>
          </div>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'freecall',
  components: {},
  data() {
    return {
      finishArea: [[], [], [], []],
      temporaryArea: [[], [], [], []],
      maingameArea: [
        [], // 7張
        [], // 7張
        [], // 7張
        [], // 7張
        [], // 6張
        [], // 6張
        [], // 6張
        [], // 6張
      ],
      cardtype: ['spade', 'heart', 'diamond', 'club'],
    };
  },
  methods: {
    shuffleCards() {
      const vm = this;
      const pokerArr = Array.from(new Array(52)).map((_, index) => index + 1);
      for (let i = pokerArr.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [pokerArr[i], pokerArr[j]] = [pokerArr[j], pokerArr[i]];
      }
      pokerArr.forEach((item) => {
        function mainpokerArr() {
          const randomarrNum = Math.floor(Math.random() * 8);
          if (randomarrNum <= 3) {
            if (vm.maingameArea[randomarrNum].length >= 7) {
              return mainpokerArr();
            }
          } else if (vm.maingameArea[randomarrNum].length >= 6) {
            return mainpokerArr();
          }
          return randomarrNum;
        }
        const runmainpokerArr = mainpokerArr();
        vm.maingameArea[runmainpokerArr].push(item);
      });
    },
    getFinishAreaImgUrl(item, index) {
      return require(`@/assets/svg/${index + 1}${item}-00.svg`);
    },
    getPokerImageUrl(item) {
      let pattern = '';
      let patternNum = '';
      let cardNum = '';
      if (item >= 1 && item <= 13) {
        pattern = 'spade'; // 1~13是黑桃
        patternNum = 1;
      } else if (item >= 14 && item <= 26) {
        pattern = 'heart'; // 14~26是紅心
        patternNum = 2;
      } else if (item >= 27 && item <= 39) {
        pattern = 'diamond'; // 27~39是方塊
        patternNum = 3;
      } else if (item >= 40 && item <= 52) {
        pattern = 'club'; // 40~52是梅花
        patternNum = 4;
      }
      switch (item % 13) {
        // case 1:
        //   cardNum = 'A';
        //   break;
        case 0:
          cardNum = '13';
          break;
        // case 12:
        //   cardNum = 'Q';
        //   break;
        // case 11:
        //   cardNum = 'J';
        //   break;
        default:
          cardNum = `${item % 13}`;
          break;
      }
      return require(`@/assets/svg/${patternNum}${pattern}-${`0${cardNum}`.substr(-2)}.svg`);
      // console.log(this.defineColor(item));
    },
    getTop(cardnum) {
      return `top: ${cardnum * 45}px;`;
    },
  },
  created() {
    this.shuffleCards();
  },
};
</script>

<style lang="scss" scoped>
.freecall {
  &__navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 23px 80px;
    background-color: $black;

    .navbar {
      &__title {
        display: flex;
        align-items: flex-end;
        color: $white;
        font-size: 60px;
        font-weight: 700;
        letter-spacing: 2px;

        & > span {
          color: $orange;
        }

        & > p {
          margin-left: 20px;
          font-size: 30px;
        }
      }

      &__time {
        display: flex;
        align-items: center;
        color: $white;

        p {
          font-size: 40px;
        }

        span {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 15px;
          border-radius: 500px;
          background-color: $orange;
          width: 60px;
          height: 60px;
          font-size: 28px;
          cursor: pointer;
        }
      }
    }
  }

  &__playground {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 42px 80px;
    .playground {
      &__temporaryarea {
        width: 45%;
      }

      &__finisharea {
        width: 45%;
      }

      &__gamingarea {
        margin-top: 30px;
        width: 100%;
      }

      &__temporaryarea,
      &__finisharea {
        display: flex;
        justify-content: space-between;

        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid $gray-m;
          border-radius: 10px;
          width: 170px;
          height: 240px;
        }
      }

      &__gamingarea {
        display: flex;
        justify-content: space-between;

        & > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          border: 2px solid $gray-m;
          border-radius: 10px;
          width: 170px;
          height: 240px;

          & > img {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }
}
</style>
